// @ts-ignore
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import styled, { css } from "styled-components";

import Select from "react-select";

import { Breadcrumb, Container, Frame, RowWrapper, TExtra } from "components/ui-kit/styled-templates";

import axios from "axios";

import ClubsApi from "api/clubs-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ERoles } from "types/enums";
import { Control } from "../ui-kit/control";

const MyClubsStatsPage = () => {
    const { t } = useTranslation();

    useBodyBackground(`white`);
    const navigate = useNavigate();
    const [statsItems, setStatsItems] = useState([]);

    const [sortConfig, setSortConfig] = useState({key: 'totalEventsNumber', direction: 'descending'});

    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);

    const clubs = useStorageListener(
        (state) => _.values(state?.clubs)?.filter?.((i: any) => i?.universityId === state?.myUniversityId) ?? []
    );

    const [filterFrom, setFilterFrom] = useState(+moment().add(-1, "months").startOf("day"));
    const [filterTo, setFilterTo] = useState(+moment().endOf("day"));

    const [filterCity, setFilterCity] = useState(undefined);
    const [filterRegion, setFilterRegion] = useState(undefined);
    const [filterUniversityName, setFilterUniversityName] = useState(undefined);

    const [filterClubName, setFilterClubName] = useState(undefined);

    let allCities = statsItems.map((club) => club?.details?.city).filter(x => (x != undefined));
    let allRegions = statsItems.map((club) => club?.details?.region).filter(x => (x != undefined));
    let allUniversitiesNames = statsItems.map((club) => club?.universityName).filter(x => (x != undefined));

    let uniqueCities = Object.keys(allCities.reduce((mp, x) => ({ ...mp, [x]: 1 }), {}));
    let uniqueRegions = Object.keys(allRegions.reduce((mp, x) => ({ ...mp, [x]: 1 }), {}));
    let uniqueUniversitiesNames = Object.keys(allUniversitiesNames.reduce((mp, x) => ({ ...mp, [x]: 1 }), {}));

    let citiesOptions = uniqueCities.map((city) => {
        return { label: city, value: city };
    });
    let regionsOptions = uniqueRegions.map((region) => {
        return { label: region, value: region };
    });
    let universitiesNamesOptions = uniqueUniversitiesNames.map((universityName) => {
        return { label: universityName, value: universityName };
    });

    let isClubAdmin = (role == ERoles.ClubsUniAdmin || role == ERoles.University);

    const handlers = {
        createClub: () => {
            ModalsService.showModal(EModals.CreateClub, { mode: `create` });
        },
        editClub: (id: string) => () => {
            ModalsService.showModal(EModals.CreateClub, { mode: `edit`, data: _.find(clubs, { id }) });
        },
        deleteClub: (id: string) => async () => {
            ModalsService.showModality({
                title: `Удаление клуба`,
                description: `Вы уверены, что хотите удалить клуб "${
                    _.find(clubs, { id })?.details?.name ?? `без названия`
                }"?`,
                cancelButton: {
                    children: `Отмена`,
                    background: `gray`,
                    onClick: () => {
                    }
                },
                confirmButton: {
                    children: `Удалить`,
                    background: `red`,
                    // onClick: async () => await ClubsApi.deleteClub(id),
                    onClick: () => {
                        ClubsApi.deleteClub(id);
                    }
                }
            });
        }
    };

    // @ts-ignore
    useEffect(ClubsApi.getMyClubs, []);

    useEffect(() => {
        axios.get(`/clubs/stats`).then(d => d.data).then(arr => {
            setStatsItems(arr);
        });
    }, []);

    console.log("render: statsItems", statsItems);

    let allClubsNames = statsItems.map((club) => club?.details?.name).filter(x => (x != undefined));
    let allClubsOptions = allClubsNames.map((clubName) => {
        return { label: clubName, value: clubName };
    });

    let fStatsItems = statsItems.filter((club) => {
        if (filterCity != undefined) {
            if (club?.details?.city != filterCity) {
                return false;
            }
        }
        if (filterRegion != undefined) {
            if (club?.details?.region != filterRegion) {
                return false;
            }
        }
        if (filterUniversityName != undefined) {
            if (club?.universityName != filterUniversityName) {
                return false;
            }
        }
        if (filterClubName != undefined) {
            if (club?.details?.name != filterClubName) {
                return false;
            }
        }
        return true;
    });

    const sortedStatsItems = React.useMemo(() => {
        let sortableItems = [...fStatsItems];
        if (sortConfig == undefined){
            return sortableItems;
        }
        if (sortConfig != undefined) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig?.key] < b[sortConfig?.key]) {
                    return sortConfig?.direction === "ascending" ? -1 : 1;
                }
                if (a[sortConfig?.key] > b[sortConfig?.key]) {
                    return sortConfig?.direction === "ascending" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [fStatsItems, sortConfig]);

    const requestSort = (key: string) => {
        let direction = "ascending";
        if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };


    return (
        <>
            {/*<EditClubModal/>*/}
            <Container extra={`align-items: flex-start;`}>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("qys77ygwrz")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <RowWrapper extra={`h1 { margin: 0; };`}>
                    <h1>{"Статистика студтурклубов"}</h1>
                </RowWrapper>
                <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 40px;`}>

                    <div>

                        {isClubAdmin == true ? null :
                            <>
                                <div>
                                    <div>
                                        {`Фильтры`}
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <Select
                                            options={citiesOptions}
                                            placeholder="Выберите город"
                                            isClearable={true}
                                            onChange={(selectedOption) => {
                                                setFilterCity(selectedOption?.value);
                                            }}
                                            value={citiesOptions.find(option => option.value === filterCity)}
                                        />
                                        <Select
                                            options={regionsOptions}
                                            placeholder="Выберите регион"
                                            isClearable={true}
                                            onChange={(selectedOption) => {
                                                setFilterRegion(selectedOption?.value);
                                            }}
                                            value={regionsOptions.find(option => option.value === filterRegion)}
                                        />
                                        <Select
                                            options={universitiesNamesOptions}
                                            placeholder="Выберите университет"
                                            isClearable={true}
                                            onChange={(selectedOption) => {
                                                setFilterUniversityName(selectedOption?.value);
                                            }}
                                            value={universitiesNamesOptions.find(option => option.value === filterUniversityName)}
                                        />
                                        <div style={{ maxWidth: 240 }}>
                                            <Select
                                                options={allClubsOptions}
                                                placeholder="Выберите студтурклуб"
                                                isClearable={true}
                                                onChange={(selectedOption) => {
                                                    setFilterClubName(selectedOption?.value);
                                                }}
                                                value={allClubsOptions.find(option => option.value === filterClubName)}
                                            />
                                        </div>


                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <div style={{ marginRight: "10px;" }}>
                                            <Control.Date
                                                value={filterFrom}
                                                onChange={evt => {
                                                    console.log("Date: onChange: evt = ", evt);
                                                    setFilterFrom(evt.target.value);
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <Control.Date
                                                value={filterTo}
                                                onChange={evt => {
                                                    console.log("Date: onChange: evt = ", evt);
                                                    setFilterTo(evt.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        <div style={{ marginTop: 20 }}>
                            {`Количество студтурклубов:  ${fStatsItems.length}`}
                        </div>

                        {/*table here  */}
                        <table style={{ width: "100%", marginTop: 15, marginBottom: 15 }}
                               className={"min-w-full leading-normal"}>
                            <thead>
                            <tr>
                                <th
                                    className={"px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"}
                                    onClick={() => requestSort("details.name")}
                                >
                                    Название
                                    <span className={"px-2"}>
                    {sortConfig?.key === "details.name" ? (sortConfig.direction === "ascending" ? "▲" : "▼") : null}
                </span>
                                </th>
                                <th
                                    className={"px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"}
                                    onClick={() => requestSort("totalEventsNumber")}
                                >
                                    Количество активных событий студтурклуба
                                    <span className={"px-2"}>
                    {sortConfig?.key === "totalEventsNumber" ? (sortConfig.direction === "ascending" ? "▲" : "▼") : null}
                </span>
                                </th>
                                <th
                                    className={"px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"}
                                    onClick={() => requestSort("doneVisitedNumber")}
                                >
                                    Количество заявок со статусом «Исполнено: приехал»
                                    <span className={"px-2"}>
                    {sortConfig?.key === "doneVisitedNumber" ? (sortConfig.direction === "ascending" ? "▲" : "▼") : null}
                </span>
                                </th>
                                <th
                                    className={"px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"}
                                    onClick={() => requestSort("doneNotVisitedNumber")}
                                >
                                    Количество заявок со статусом «Исполнено: не приехал»
                                    <span className={"px-2"}>
                    {sortConfig?.key === "doneNotVisitedNumber" ? (sortConfig.direction === "ascending" ? "▲" : "▼") : null}
                </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {sortedStatsItems.map((a, i) => {
                                return (
                                    <tr key={a.id}>
                                        <td className={"px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"}>{a?.details?.name}</td>
                                        <td className={"px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"}>{a?.totalEventsNumber}</td>
                                        <td className={"px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"}>{a?.doneVisitedNumber}</td>
                                        <td className={"px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"}>{a?.doneNotVisitedNumber}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>

                        {/*<div style={{ marginTop: 15, marginBottom: 15 }}>*/}
                        {/*    {fStatsItems.map((a, i) => {*/}
                        {/*        return (*/}
                        {/*            <div key={a.id}>*/}
                        {/*                <div style={{ fontWeight: "bold" }}>*/}
                        {/*                    {a?.details?.name}*/}
                        {/*                </div>*/}
                        {/*                <div>*/}
                        {/*                    <ul>*/}
                        {/*                        <li>*/}
                        {/*                            {`Количество активных событий студтурклуба: ${a?.totalEventsNumber}`}*/}
                        {/*                        </li>*/}
                        {/*                        <li>*/}
                        {/*                            {`Количество заявок со статусом «Исполнено: приехал»: ${a?.doneVisitedNumber}`}*/}
                        {/*                        </li>*/}
                        {/*                        <li>*/}
                        {/*                            {`Количество заявок со статусом «Исполнено: не приехал»: ${a?.doneNotVisitedNumber}`}*/}
                        {/*                        </li>*/}

                        {/*                    </ul>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        );*/}
                        {/*    })}*/}
                        {/*</div>*/}

                        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <span
                                style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    opacity: 0.8,
                                    fontSize: "12px"
                                }}
                                onClick={() => {
                                    let csvContent = "data:text/csv;charset=utf-8,";
                                    // csvContent += "data:text/csv;charset=utf-8,";
                                    csvContent += "название;Количество активных событий студтурклуба;Количество заявок со статусом «Исполнено: приехал»;Количество заявок со статусом «Исполнено: не приехал»";
                                    csvContent += "\n";
                                    fStatsItems.forEach((row) => {
                                        csvContent += `${row?.details?.name};${row?.totalEventsNumber};${row?.doneVisitedNumber};${row?.doneNotVisitedNumber}`;
                                        csvContent += "\n";
                                    });
                                    var encodedUri = encodeURI(csvContent);
                                    var link = document.createElement("a");
                                    link.setAttribute("href", encodedUri);
                                    link.setAttribute("download", "статистика.csv");
                                    document.body.appendChild(link); // Required for FF
                                    link.click();
                                }}
                            >
                                экспорт в Excel
                            </span>
                        </div>

                    </div>


                    {/*{clubs?.map?.(({ details: item = {}, id, onModeration }: any, index: any) => (*/}
                    {/*    <ClubTab.Component key={index} {...{ item, id, handlers, onModeration }} />*/}
                    {/*))}*/}
                </RowWrapper>
                {/*{!clubs.length && <NotFoundWrapper>{t("3085txvws7m")}</NotFoundWrapper>}*/}
            </Container>
        </>
    );
};


enum EClubTabStatus {
    Accept = `accept`,
    Reject = `reject`,
    Process = `process`,
    None = `none`,
    Verification = `verification`,
}

const tooltipStatusText = {
    [EClubTabStatus.Accept]: `Все данные успешно заполнены, проверка пройдена`,
    [EClubTabStatus.Verification]: `Все данные успешно заполнены, ожидает проверки`,
    [EClubTabStatus.Reject]: `Ожидает заполнения`,
    [EClubTabStatus.Process]: `Ожидает заполнения`,
    [EClubTabStatus.None]: `Ожидает заполнения`
};


export const ClubTab = {
    Component: (props: { onModeration: boolean; item: any; id: string; handlers: { editClub: Function; deleteClub: Function } }) => {
        const { t } = useTranslation();

        const { item, id, handlers, onModeration } = props;

        const status = onModeration ? EClubTabStatus.Verification : EClubTabStatus.Accept;

        return (
            <ClubTab.Wrapper>
                <ClubTab.WarningSign status={status} />
                <ClubTab.Name empty={_.isEmpty(item?.name)}>{item?.name ?? `Без имени`}</ClubTab.Name>
                {/*<ClubTab.Type>{EVENT_TYPES_OPTIONS?.find?.((i) => i?.value === item?.type)?.clubel}</ClubTab.Type>*/}
                <ClubTab.DetailsWrapper>
                    {/*<div>*/}
                    {/*    <div>Стоимость на 1 человека:</div>*/}
                    {/*    <strong>{item?.price} ₽</strong>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <div>Даты проведения:</div>*/}
                    {/*    <strong>*/}
                    {/*        {moment(item?.dates?.from).format(`DD.MM`)} - {moment(item?.dates?.to).format(`DD.MM`)}*/}
                    {/*    </strong>*/}
                    {/*</div>*/}
                </ClubTab.DetailsWrapper>
                {/*<Link to={`/clubs/${id}`}>*/}
                {/*    <ClubTab.Link color="blue">Предпросмотр</ClubTab.Link>*/}
                {/*</Link>*/}
                <ClubTab.Link color="blue" onClick={handlers.editClub(id)}>
                    {t("pzj6pcmxt3p")}
                </ClubTab.Link>
                <ClubTab.Link color="red" onClick={handlers.deleteClub(id)}>
                    {t("qlpwlvqsvva")}
                </ClubTab.Link>
            </ClubTab.Wrapper>
        );
    },
    Type: styled(Frame)`
      color: ${({ theme }) => theme.blue};
      font-size: 13px;
      line-height: 17px;
    `,
    WarningSign: styled(Frame)<{ status?: EClubTabStatus }>`
      width: 24px;
      height: 24px;
      background: url("${({ status = EClubTabStatus.None }) => require(`assets/icons/dormitory-status-${status}.svg`)}") no-repeat center center /
            contain;

      position: absolute;
      top: 10px;
      right: 10px;
    `,
    Wrapper: styled(Frame)<{ status?: EClubTabStatus }>`
      width: calc(50% - 20px);
      padding: 24px 20px;
      box-sizing: border-box;
      border: 1px solid ${({ theme }) => theme.halfblue};
      border-radius: 8px;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px 0;
      position: relative;

      > * {
        margin: 0;
      }

      @media (max-width: 991px) {
        width: inherit;
      }
    `,
    Name: styled.h3<{ empty: boolean; extra?: TExtra }>`
      color: ${({ theme, empty }) => (empty ? theme.text.light : theme.text.primary)};

      ${({ extra }) => extra}
    `,
    Link: styled(Frame)<{ color: `red` | `blue`; direction?: `right` | `left` }>`
      color: ${({ theme, color }) => theme[color]};
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      align-items: center;
      flex-direction: row;
      cursor: pointer;

      ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
        content: "";
        width: 12px;
        height: 12px;
        background: url("${({ color }) => require(`assets/icons/arrow-right-${color}.svg`)}") no-repeat center center / contain;
        margin-left: 8px;
        transition: 0.2s;

        ${({ direction = `right` }) =>
                direction === `left` &&
                css`
                  transform: rotate(180deg);
                  margin-left: unset;
                  margin-right: 8px;
                `}
      }

      &:hover {
        ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
          transform: translateX(${({ direction = `right` }) => (direction === `right` ? 3 : -3)}px) ${({ direction = `right` }) => (direction === `left` ? `rotate(180deg)` : ``)};
        }
      }
    `,
    DetailsWrapper: styled(RowWrapper)`
      > * {
        margin-bottom: 8px;
        width: 100%;

        p {
          margin-bottom: 8px;
        }
      }

      @media (max-width: 991px) {
        flex-wrap: wrap;
        > * {
          width: 50%;
        }
      };
    `
};

export const NotFoundWrapper = styled(Frame)`
  width: inherit;
  color: ${({ theme }) => theme.grey};
  padding: 40px 0;
`;

export default MyClubsStatsPage;
